import { createContext, useContext, useState, ReactNode } from 'react';
import { Snackbar, Alert } from '@mui/material';

interface ErrorContextType {
    showError: (message: string) => void;
}

interface ErrorItem {
    id: number;
    message: string;
}

const ErrorContext = createContext<ErrorContextType | undefined>(undefined);

export function ErrorProvider({ children }: { children: ReactNode }) {
    const [errors, setErrors] = useState<ErrorItem[]>([]);
    const [nextId, setNextId] = useState(1);

    const showError = (message: string) => {
        setErrors(prev => [...prev, { id: nextId, message }]);
        setNextId(prev => prev + 1);
    };

    const handleClose = (id: number) => {
        setErrors(prev => prev.filter(error => error.id !== id));
    };

    return (
        <ErrorContext.Provider value={{ showError }}>
            {children}
            {errors.map((error, index) => (
                <Snackbar
                    key={error.id}
                    open={true}
                    autoHideDuration={6000}
                    onClose={() => handleClose(error.id)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    style={{ top: 24 + index * 70 }}
                >
                    <Alert onClose={() => handleClose(error.id)} severity="error">
                        {error.message}
                    </Alert>
                </Snackbar>
            ))}
        </ErrorContext.Provider>
    );
}

export function useError() {
    const context = useContext(ErrorContext);
    if (context === undefined) {
        throw new Error('useError must be used within an ErrorProvider');
    }
    return context;
}